import PropTypes from "prop-types"
import React from "react"

import { PlanNames } from "views/User/views/Plans/helpers/plans"

import PricingItem from "./PricingItem"

const Regular = props => {
  const { plan, lang } = props

  return (
    <div className="flex-container f-a-start m-t-25">
      <PricingItem
        price={plan.price}
        subscriptionPeriod={plan.subscription_period}
        lang={lang}
        showAsterisk={plan.name === PlanNames.StarterMonthly}
      />
    </div>
  )
}

Regular.propTypes = {
  plan: PropTypes.object,
  lang: PropTypes.string,
}
Regular.defaultProps = { plan: {}, lang: "en" }

export default Regular
